import VikahLogo from "../assests/VikahLogo.png";
import RST4000Image from "../assests/R4.png";
import TyreBalerImage from "../assests/TyreBaler.png";

export const navbarPromotions = [
  // =====================================================
  // COMPANY INFORMATION
  // =====================================================
  {
    id: "vikah-ecotech",
    logo: VikahLogo,
    title: "VIKAH ECOTECH",
    subtitle: "Industrial Recycling Solutions",
    description:
      "Discover innovative recycling machinery and sustainable industrial solutions from Vikah Ecotech.",
    url: "https://vikahecotech.com",
  },

  // =====================================================
  // TYRE BALER
  // =====================================================
  {
    id: "tyre-scrap-balers",
    logo: TyreBalerImage,
    title: "Tyre Scrap Balers",
    subtitle: "Efficient Tyre Scrap Processing",
    description:
      "Discover powerful tyre scrap baling solutions designed for easier handling, storage and transportation.",
    url: "https://vikahecotech.com/tyre-scrap-balers",
  },

  // =====================================================
  // RST-4000
  // =====================================================
  {
    id: "rst-4000",
    logo: RST4000Image,
    title: "RST-4000",
    subtitle: "Advanced Rubber Recycling Machine",
    description:
      "Explore the RST-4000, designed for efficient processing of rubber materials and recycling applications.",
    url: "https://vikahecotech.com/rst4000",
  },

  // =====================================================
  // VISIT US
  // =====================================================
  {
    id: "visit-us",
    logo: VikahLogo,
    title: "Please Visit Us",
    subtitle: "Explore More Recycling Solutions",
    description:
      "Please visit us for more information about our recycling machinery, industrial solutions and products.",
    url: "https://vikahecotech.com",
  },
];

export {
  RST4000Image,
  TyreBalerImage,
};